export default __webpack_public_path__ + "static/media/user-avatar.402e33f3.png";